import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useConfirmAnalyses from 'hooks/useConfirmAnalyses';
import { confirmAnalysesSelectors } from "features/confirmAnalyses";

const ConfirmAnalysesList = () => {
  const { getConfirmAnalyses } = useConfirmAnalyses();
  const { data, pagination } = useCustomSelector(confirmAnalysesSelectors.getConfirmAnalysesData);
  const fetching = useCustomSelector(confirmAnalysesSelectors.confirmAnalysesIsFetching);
  
  return (
    <BaseAnalysesList
      fetchData={getConfirmAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ConfirmAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);